import React from "react";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";

// The strip is only 14px tall, which made its two links ~14px tap targets — well
// under the 44px minimum, and this is the ONLY header chrome on mobile (NavigationBar
// is `hidden lg:inline-flex`).
//
// The bar's height is NOT adjustable here: `top-[14px]` is a site-wide constant that
// nine other mobile surfaces are pinned to (contact, become-partner, cart, booking,
// user/dashboard, user/personal-info, user/booking-list, SearchPage/navigation,
// TitleBar, PartnerHeader). Growing the strip would push every one of those into
// overlap; hiding it would leave each a 14px dead gap.
//
// So the hit area is extended DOWNWARD with a transparent ::after overlay instead —
// ~37px of usable target, zero change to the painted box and zero layout movement
// anywhere. The overlay only ever covers the top-right of the hero image: the
// breadcrumb is left-aligned and hero content starts at mt-[100px], so it intercepts
// nothing. `gap-6` keeps the two expanded targets from touching (8px+ rule); the
// desktop bar is unchanged (lg:after:hidden, lg:gap-3).
const HeaderBar = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-[14px] z-20 flex items-center justify-end px-[4%] gap-6 lg:gap-3 bg-gradient-to-r from-primary to-primary-dark text-white text-[11px] font-medium uppercase tracking-widest">
      <a
        href="https://wa.me/918884414400"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
        className="relative inline-flex items-center justify-center opacity-90 hover:opacity-100 transition-opacity after:absolute after:content-[''] after:inset-x-[-12px] after:top-[-6px] after:bottom-[-24px] lg:after:hidden"
      >
        <FaWhatsapp className="w-[10px] h-[10px] mr-1.5 text-whatsapp" aria-hidden="true" />
      </a>

      <a
        href="tel:+918884414400"
        aria-label="Call us at +91 8884414400"
        className="relative inline-flex items-center gap-1.5 opacity-90 hover:opacity-100 hover:underline transition-all after:absolute after:content-[''] after:inset-x-0 after:top-[-6px] after:bottom-[-24px] lg:after:hidden"
      >
        <FaPhoneAlt className="w-[10px] h-[10px]" aria-hidden="true" />
        +91 - 8884414400
      </a>
    </div>
  );
};

export default HeaderBar;
